const e = {
  name: "Berlin",
  dimensions: { width: 14, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 14 40" style="enable-background:new 0 0 14 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,19c0-3.5-2.6-6.4-6-6.9V10h1V8H8V0H6v8H5v2h1v2.1c-3.4,0.5-6,3.4-6,6.9c0,0.8,0.1,1.6,0.4,2.3
			c0.6,1.7,1.8,3,3.3,3.9L3.6,28H2v2h1.5l-0.1,2H2v2h1.2L3,38v2h2v-2l0.2-4h3.5L9,38v2h2v-2l-0.2-4H12v-2h-1.4l-0.1-2H12v-2h-1.6
			l-0.2-2.8c1.5-0.8,2.8-2.2,3.3-3.9C13.9,20.6,14,19.8,14,19z M5.4,32l0.1-2h3.1l0.1,2H5.4z M5.6,28l0.1-2.1C6.1,26,6.6,26,7,26
			c0.4,0,0.9,0,1.3-0.1L8.4,28H5.6z M2,19c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,0.3,0,0.7-0.1,1H2.1C2,19.7,2,19.3,2,19z M3,22h8
			c-0.5,0.7-1.3,1.3-2.2,1.7C8.3,23.9,7.7,24,7,24c-0.7,0-1.3-0.1-1.8-0.3C4.3,23.3,3.6,22.7,3,22z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Berlin
};
